import * as z from 'zod';

export const unitSellBysQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
  plural: z.string().nullable(),
});

export type UnitSellBysQueryLinkerSchema = z.infer<typeof unitSellBysQueryLinkerSchema>;
